"use client"
import React, { useEffect, useState } from "react"
import Link from "next/link"
import clsx from "clsx"

import { linkUnderlineClass } from "@/data/styles"
import { /* LanguageIcon, */ PhoneIcon, /* SearchIcon, */ WhatsAppIcon } from "@/components/icons"
import { MobileMenu } from "./MobileMenu"
import { HeaderIcon } from "./HeaderIcon"
import { MenuIcon } from "./MenuIcon"
import { HeaderLink, HeaderVariant, logoComponent } from "./constants"
import { HomeNav } from "./HomeNav"
import { usePathname } from "next/navigation"
import { getHeaderClasses } from "@/utils/helpers"

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  variant?: HeaderVariant
  iconsPresent?: boolean
  links?: HeaderLink[]
  homeLinks?: HeaderLink[]
}

const headerIcons = [
    { Icon: PhoneIcon, href: "tel:+971585014312" },
    { Icon: WhatsAppIcon, href: "https://wa.me/971585014312" }
  ]

export default function Header({ variant="transparent", iconsPresent=true, links, homeLinks, className, ...props }: HeaderProps) {
  const pathname = usePathname()
  
  const [isScrolled, setIsScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  
  const Logo = logoComponent[variant]

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 10)
    handleScroll()
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])


  return (
    <header {...props} className={getHeaderClasses(variant, isScrolled, className)}>
      <div className={clsx(
        "max-w-[1440px] mx-auto px-[20px] md:px-[50px] flex flex-row justify-between transition-all duration-300",
        isScrolled ? "py-[20px]" : "py-[40px]")}
      >
        <Link href={"/"} aria-label="logo">
          <Logo className={clsx(isScrolled && "scale-80 origin-left", "transition-all duration-300 w-[100px] md:w-[120px] xl:w-[187px] h-auto")} />
        </Link>
        
        <div className="hidden xl:flex xl:flex-row">
          <div className={clsx("flex flex-row gap-[50px] items-center transition-all duration-300", isScrolled && "scale-85 origin-right")}>
            {links?.map((link, index) => {
              const isActive = pathname === link.href
              return (
                <Link key={index} href={link?.href ?? "#"}
                  className={clsx(linkUnderlineClass, "w-fit", isActive && "after:w-full after:opacity-100")}
                >
                  {link.label}
                </Link>
              )
            })}
          </div>

          {homeLinks && homeLinks.length > 0 && <HomeNav homeLinks={homeLinks} />}

          {iconsPresent && (
            <div className={clsx("flex flex-row items-center gap-[24px]", links && "ml-[92px]")}>
              {headerIcons.map(({ Icon, href }, idx) => (
                <HeaderIcon key={idx} variant={variant} isScrolled={isScrolled} Icon={Icon} href={href} />
              ))}
            </div>
          )}
        </div>

        {/* Mobile nav */}
        <MenuIcon variant={variant} isScrolled={isScrolled} openMenu={() => setMenuOpen(true)} />
        <MobileMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} links={links} homeLinks={homeLinks} icons={headerIcons} />
      </div>
    </header>
  )
}
